// src/pages/Login.tsx
import React from "react";
import LineLoginButton from "../components/User/LineLoginButton"; // ← ここ
import { setAuth } from "../lib/auth";

export default function Login() {
  const onSuccess = (payload: any) => {
    setAuth(payload?.token, payload?.user);
    window.location.replace("/");
  };

  return (
    <main style={{ textAlign: "center", padding: "40px 16px" }}>
      <h1>BOAT億MAN ログイン</h1>
      <p>LINEでログインして続行します。</p>
      <div style={{ marginTop: 24 }}>
        <LineLoginButton onSuccess={onSuccess} />
      </div>
    </main>
  );
}
